import { Configuration } from '@deckee/api-app-main';
import { ApiClientMiddleware } from './ApiClientMiddleware';

const apiConfiguration = new Configuration({
  basePath: window.location.origin,
  middleware: [new ApiClientMiddleware()],
});

export default apiConfiguration;
